import { useState } from 'react';
import type { AccountModel, KhachHang, NgoaiTe, NhomKhachHang } from '@/types/schemas';

type CustomerGroup = NhomKhachHang & { uuid?: string };

export interface SearchFieldStates {
  ngoaiTe: NgoaiTe | null;
  taiKhoan: AccountModel | null;
  khachHang: KhachHang | null;
  nhomKhachHang1: CustomerGroup | null;
  nhomKhachHang2: CustomerGroup | null;
  nhomKhachHang3: CustomerGroup | null;
  setNgoaiTe: (value: NgoaiTe | null) => void;
  setTaiKhoan: (value: AccountModel | null) => void;
  setKhachHang: (value: KhachHang | null) => void;
  setNhomKhachHang1: (value: CustomerGroup | null) => void;
  setNhomKhachHang2: (value: CustomerGroup | null) => void;
  setNhomKhachHang3: (value: CustomerGroup | null) => void;
}

export const useSearchFieldStates = (): SearchFieldStates => {
  const [ngoaiTe, setNgoaiTe] = useState<NgoaiTe | null>(null);
  const [taiKhoan, setTaiKhoan] = useState<AccountModel | null>(null);
  const [khachHang, setKhachHang] = useState<KhachHang | null>(null);
  const [nhomKhachHang1, setNhomKhachHang1] = useState<CustomerGroup | null>(null);
  const [nhomKhachHang2, setNhomKhachHang2] = useState<CustomerGroup | null>(null);
  const [nhomKhachHang3, setNhomKhachHang3] = useState<CustomerGroup | null>(null);

  return {
    ngoaiTe,
    taiKhoan,
    khachHang,
    nhomKhachHang1,
    nhomKhachHang2,
    nhomKhachHang3,
    setNgoaiTe,
    setTaiKhoan,
    setKhachHang,
    setNhomKhachHang1,
    setNhomKhachHang2,
    setNhomKhachHang3
  };
};
